module.exports = __webpack_public_path__ + "static/media/savio16.3c220251.jpg";